(function() {
  'use strict';

  var cartDrawerEl = document.getElementById('cart-drawer');
  var cartOverlay = document.getElementById('cart-drawer-overlay');

  window.__cartDrawer = {
    open: function() {
      cartDrawerEl.classList.add('cart-drawer--open');
      cartOverlay.classList.add('cart-drawer-overlay--visible');
      document.body.style.overflow = 'hidden';
      cartDrawerEl.setAttribute('aria-hidden', 'false');
    },
    close: function() {
      cartDrawerEl.classList.remove('cart-drawer--open');
      cartOverlay.classList.remove('cart-drawer-overlay--visible');
      document.body.style.overflow = '';
      cartDrawerEl.setAttribute('aria-hidden', 'true');
    },
    toggle: function() {
      if (cartDrawerEl.classList.contains('cart-drawer--open')) {
        this.close();
      } else {
        this.open();
      }
    }
  };

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      window.__cartDrawer.close();
      document.querySelector('.search-overlay')?.classList.remove('search-overlay--open');
      document.querySelector('.mobile-nav')?.classList.remove('mobile-nav--open');
    }
  });

  window.updateCartItem = function(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var countEl = document.getElementById('cart-count');
      var drawerCountEl = document.getElementById('drawer-cart-count');
      if (countEl) countEl.textContent = cart.item_count;
      if (drawerCountEl) drawerCountEl.textContent = cart.item_count;
      location.reload();
    })
    .catch(function(err) {
      console.error('Cart update failed:', err);
    });
  };

  var productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var formData = new FormData(productForm);
      var data = {
        id: parseInt(formData.get('id')),
        quantity: parseInt(formData.get('quantity')) || 1
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [data] })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            var countEl = document.getElementById('cart-count');
            if (countEl) countEl.textContent = cart.item_count;
            window.__cartDrawer.open();
            location.reload();
          });
      })
      .catch(function(err) {
        console.error('Add to cart failed:', err);
      });
    });
  }

  // Particle background animation
  function createParticles() {
    var container = document.getElementById('particles-js');
    if (!container) return;
    
    var particleCount = 20;
    for (var i = 0; i < particleCount; i++) {
      var particle = document.createElement('div');
      particle.className = 'particle';
      
      var size = Math.random() * 4 + 1;
      var left = Math.random() * 100;
      var duration = Math.random() * 15 + 10;
      var delay = Math.random() * 10;
      
      particle.style.width = size + 'px';
      particle.style.height = size + 'px';
      particle.style.left = left + '%';
      particle.style.animationDuration = duration + 's';
      particle.style.animationDelay = '-' + delay + 's';
      
      container.appendChild(particle);
    }
  }
  
  createParticles();

  document.addEventListener('click', function(e) {
    var mobileNav = document.querySelector('.mobile-nav');
    var menuToggle = document.querySelector('.site-header__menu-toggle');
    if (mobileNav && mobileNav.classList.contains('mobile-nav--open')) {
      if (!mobileNav.contains(e.target) && !menuToggle.contains(e.target)) {
        mobileNav.classList.remove('mobile-nav--open');
      }
    }
  });
})();
